jQuery(document).ready(function(){
  $slide = $('.home-paralax');
  winH = $(window).height();
   $slide.height(winH);
        var skrollr_init = skrollr.init({
   mobileCheck: function() {
                return false;
            }
        });
  
    })